import React, {ReactElement} from 'react'
import Head from 'next/head'
import NextNProgress from 'nextjs-progressbar'
import Footer from '@/components/Footer'
import Header from '@/components/Header'
import {useQuery} from 'react-query'
import GetFeaturedCategories from '@/services/api/products/GetFeaturedCategories'
import {GetSettings} from '@/services/api/settings'
import GetAllCategories from '@/services/api/products/GetAllCategories'
import FloatingCartButton from '@/components/Cart/FloatingCartButton'
export default function Layout({children}: {children: ReactElement}) {
  const {data} = useQuery(['featured_categories'], GetFeaturedCategories)
  const {data: settings, isLoading} = useQuery(['settings'], GetSettings)
  const {data: categories} = useQuery(['categories'], GetAllCategories)
  return (
    <>
      <Head>
        <meta name="description" content="Basmti" />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <NextNProgress color="#00214D" />
      <Header
        featured_categories={data}
        settings={settings}
        categories={categories}
      />
      <FloatingCartButton />
      {children}
      {settings && <Footer featured_categories={data} settings={settings} />}
    </>
  )
}
